import React, { useEffect, useState } from "react";
import TopNav from "../global-components/top_nav";
import { Col, Row } from "reactstrap";
import MealsBookingForm from "./MealsBookingForm";
import requests from "../../utils/Requests";
import axios from "axios";
import { useParams } from "react-router";
import Footer from "../global-components/footer";
const MealsDetails = () => {
  const { id } = useParams();
  const [mealtypeDetails, setMealTypeDetails] = useState(null);
  useEffect(() => {
    getmealTypeList();
  }, [id]);

  const getmealTypeList = async () => {
    try {
      const res = await axios.post(requests.getMealType, { mealTypeId: id });

      console.log(res.data);
      setMealTypeDetails(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <TopNav />

      <div
        className="container"
        style={{
          marginTop: "24px",
          marginBottom: "24px",
        }}
      >
        <img
          src={requests.imgpath + mealtypeDetails?.galleryImage}
          style={{
            width: "100%",
            height: "400px",
          }}
        />
        <Row>
          <Col md={8}>
            <div>
              <h3>Description</h3>

              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: mealtypeDetails?.description,
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md={4}>
            <MealsBookingForm />
          </Col>
        </Row>
      </div>

      <Footer />
    </div>
  );
};

export default MealsDetails;
